"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _default = {
  DRAFT: "Draft",
  PENDING_MASTER: "Building",
  EDITING: "Editing",
  INTERNAL_REVIEW: "Internal Review",
  PENDING_REVIEW: "Pending Review",
  APPROVED: "Approved",
  PENDING_SOCIAL_REVIEW: "Pending Social Review",
  COST_REVIEW: "Cost Review",
  ON_HOLD: "On Hold"
};
exports["default"] = _default;